'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TabContent = require('./components/TabContent.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TabContent).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-tabs/lib/components/tab-content/index.js
// module id = 524
// module chunks = 1